export default {"src":"/_next/static/media/0xd586e7f844cea2f87f50152665bcbc2c279d8d70.ccfaf818.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};